(function () {
  'use strict';
  /* This drawer used to be a second, private shopping bag kept in
     localStorage. It never spoke to Shopify, so the header count, the drawer
     contents and the real cart were three different numbers: the pack builder
     and the product form both post to Shopify and left the counter reading
     zero, while the sticky Add to bag wrote only to localStorage, so it showed
     an item that checkout had never heard of. The bag below is now the Shopify
     cart and nothing else. */
  var key = 'wellubia-bag-v1';
  try { localStorage.removeItem(key); } catch (_) {}
  var CFG = window.WELLUBIA_SHOP || {MODE:'local',DOMAIN:'',FREE_SHIPPING:0,VARIANTS:{},
    checkoutHref:function(){return '/cart';}, buyNowHref:function(h,q){return '/pages/cart?buy='+h+'&qty='+q;},
    external:function(){return false;}};
  var FREE_SHIPPING = CFG.FREE_SHIPPING;
  var product = window.WELLUBIA_PRODUCT;
  var bag = [];

  var panel = document.getElementById('bag');
  var overlay = document.getElementById('bagOverlay');
  var count = document.getElementById('bagCount');
  var items = document.getElementById('bagItems');
  var total = document.getElementById('bagTotal');
  var order = document.getElementById('orderLink');
  var gallery = document.querySelector('.product-gallery');
  var qtyInput = document.getElementById('qtyInput');
  var buyNow = document.getElementById('buyNow');
  var sticky = document.getElementById('stickyBuy');
  var money = function (n) { return '₹' + n.toLocaleString('en-IN'); };
  var price = function (v) { return Number(String(v).replace(/[^0-9]/g, '')) || 0; };
  /* product.price is a formatted string, "Rs. 225.00". Stripping every
     non-digit from it removes the decimal point too, so 225.00 came back as
     22500 and every figure built on it was a hundred times too large: a four
     bottle basket reported a saving of 18,000 rupees. The page now carries the
     number as well as the words. */
  var unitPrice = function () {
    if (product && typeof product.priceNum === 'number') return product.priceNum / 100;
    return price(product && product.price) / 100;
  };
  var qty = function () { return Math.max(1, Math.min(99, parseInt(qtyInput && qtyInput.value, 10) || 1)); };
  var scrollLock = window.WellubiaScrollLock;
  if (!scrollLock) {
    scrollLock = window.WellubiaScrollLock = {
      depth: 0,
      y: 0,
      lock: function () {
        if (this.depth++ > 0) return;
        this.y = window.scrollY || window.pageYOffset || 0;
        document.documentElement.classList.add('wl-overlay-locked');
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + this.y + 'px';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
      },
      unlock: function () {
        if (this.depth === 0 || --this.depth > 0) return;
        document.documentElement.classList.remove('wl-overlay-locked');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        window.scrollTo(0, this.y);
      }
    };
  }

  /* One request, one source of truth. Every mutation goes to Shopify and the
     drawer is redrawn from whatever Shopify says the cart now holds, so the
     two can never drift apart again. */
  var cartTotals = { payable: 0, before: 0, saved: 0 };
  function readCart(data) {
    /* Shopify already knows the discounted figure. The drawer used to add up
       line.price, which is the price before the pack saving, so it showed 450
       on a bag Shopify was about to charge 382.50 for. */
    cartTotals = {
      payable: (data && data.total_price || 0) / 100,
      before: (data && data.items_subtotal_price || 0) / 100,
      saved: (data && data.total_discount || 0) / 100
    };
    bag = (data && data.items ? data.items : []).map(function (line) {
      /* final_price is what the bottle costs once the pack discount has been
         shared across the lines. price is what it costs on its own, which is
         what the drawer used to show while the till charged the other one. */
      var now = (typeof line.final_price === 'number' ? line.final_price : line.price) / 100;
      var was = typeof line.original_price === 'number' ? line.original_price / 100 : null;
      return {
        line: line.key,
        handle: line.handle,
        name: line.product_title,
        price: now,
        was: (was !== null && was > now) ? was : null,
        qty: line.quantity,
        img: line.image || ''
      };
    });
    render();
  }
  function sync() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (d) readCart(d); })
      .catch(function () {});
  }
  /* The pack builder and anything else that changes the cart can call this to
     bring the header and drawer back in step. */
  window.wellubiaCartSync = sync;

  /* add_to_cart and begin_checkout were already firing, but without view_item
     there is no denominator: you can count the adds and never know what share
     of visitors added. That ratio is the one number worth watching before
     paying for traffic, so the event has to exist first. */
  if (product && product.handle && window.wellubiaTrack) {
    window.wellubiaTrack('view_item', {
      ecommerce: { currency: 'INR', value: unitPrice(), items: [{
        item_id: product.handle, item_name: product.name, price: unitPrice(), quantity: 1
      }] }
    });
  }

  /* Bags written by other pages may hold a path relative to the site root.
     Resolve it here so the drawer thumbnails work from /products/ too. */
  function imgSrc(item) {
    var src = item.img;
    if (!src) return 'wl-ass-images-brand-wellubia-logo-mark.png';
    if (/^(https?:|data:|\/)/.test(src)) return src;
    return new URL(src.replace(/^\.\//, ''), location.origin + '/').pathname;
  }

  /* Shopify multi-add permalink: /cart/{variantId}:{qty},... */
  function checkoutHref() { return CFG.checkoutHref(bag, '../'); }

  function progressMarkup(subtotal) {
    return '<p class="bag-ship done">Free delivery on every order across India.</p>';
  }

  var saveLine = document.getElementById('bagSave');
  var upsell = document.getElementById('bagUpsell');
  var pool = (function () {
    var tag = document.getElementById('bagPool');
    if (!tag) return [];
    try { return JSON.parse(tag.textContent) || []; } catch (_) { return []; }
  })();
  /* One offer per drawer opening, not one per redraw, so the bottle and the
     wording hold still while the shopper reads them. */
  var offerSeed = Math.random();

  /* A ready combination is one cart line holding two, three or four bottles,
     and the Potli is an add-on rather than a bottle. shop-config knows both;
     counting lines here instead was refusing perfectly valid combo orders. */
  function bottleCount() {
    if (typeof CFG.bottleCount === 'function') return CFG.bottleCount(bag);
    return bag.reduce(function (n, i) {
      return n + (i.handle === 'wellubia-gift-hamper' ? 0 : i.qty);
    }, 0);
  }
  function renderUpsell() {
    if (!upsell) return;
    var n = bottleCount();
    if (!n || n >= 4) { upsell.hidden = true; upsell.innerHTML = ''; return; }
    var held = bag.map(function (i) { return i.handle; });
    var open = pool.filter(function (p) { return held.indexOf(p.h) === -1; });
    if (!open.length) { upsell.hidden = true; upsell.innerHTML = ''; return; }
    /* Weight the ones Wellubia names as its best, then pick one. */
    var best = open.filter(function (p) { return p.b; });
    var from = best.length ? best : open;
    var pick = from[Math.floor(offerSeed * from.length) % from.length];

    var reward = n === 1 ? 'save 15%' : n === 2 ? 'save 20%' : 'get the Potli for \u20b959';
    var lines = [
      'Add ' + pick.t + ' and ' + reward,
      'Make it ' + (n + 1) + ' bottles and ' + reward,
      pick.b ? 'Add ' + pick.t + ', one of our best sellers, and ' + reward
             : 'Add ' + pick.t + ' and ' + reward,
      'One more bottle and you ' + reward + '. Try ' + pick.t + '.'
    ];
    var say = lines[Math.floor(offerSeed * 100) % lines.length];
    upsell.hidden = false;
    upsell.innerHTML =
      '<button type="button" class="bag-upsell-add" data-upsell-variant="' + pick.v + '">' +
      '<span class="bag-upsell-say">' + say + '</span>' +
      '<span class="bag-upsell-price">+' + money(pick.p / 100) + '</span></button>';
  }
  if (upsell) upsell.addEventListener('click', function (event) {
    var b = event.target.closest('[data-upsell-variant]');
    if (!b) return;
    b.disabled = true;
    b.classList.add('is-adding');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(b.dataset.upsellVariant), quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error(String(r.status)); return sync(); })
      .catch(function () { b.disabled = false; b.classList.remove('is-adding'); });
  });

  function render() {
    var quantity = bag.reduce(function (s, i) { return s + i.qty; }, 0);
    var subtotal = cartTotals.payable || bag.reduce(function (s, i) { return s + i.price * i.qty; }, 0);
    if (count) count.textContent = quantity;
    if (total) total.textContent = money(subtotal);
    if (saveLine) {
      if (cartTotals.saved > 0) {
        saveLine.hidden = false;
        var delivery = Number(CFG.DELIVERY_SAVING) || 0;
        saveLine.innerHTML = '<s>' + money(cartTotals.before) + '</s> You save ' +
          money(cartTotals.saved + delivery) + ' <span>' + money(cartTotals.saved) +
          ' discount and ' + money(delivery) + ' free delivery</span>';
      } else {
        saveLine.hidden = true;
      }
    }
    renderUpsell();
    if (!bag.length) {
      items.innerHTML = '<p class="empty">Your bag is empty.</p>';
      if (order) { order.href = '/#bazaar'; order.textContent = 'Browse the range'; }
      return;
    }
    items.innerHTML = bag.map(function (item, index) {
      return '<article class="bag-item"><img src="' + imgSrc(item) + '" alt=""><div><strong>' + item.name +
        '</strong><small>' + (item.was ? '<s>' + money(item.was) + '</s> ' : '') + money(item.price) + '</small><p><button type="button" data-action="minus" data-index="' + index +
        '" aria-label="Decrease quantity">−</button><span>' + item.qty +
        '</span><button type="button" data-action="plus" data-index="' + index +
        '" aria-label="Increase quantity">+</button><button type="button" class="bag-remove" data-action="remove" data-index="' +
        index + '" aria-label="Remove ' + item.name + '">Remove</button></p></div></article>';
    }).join('') + progressMarkup(subtotal);
    if (order) {
      /* This button used to be a Shopify cart permalink for everybody. A
         permalink builds the cart and lands straight in checkout, so it went
         around the bag page and with it the two bottle minimum: a single
         bottle could be paid for from this drawer. Below the minimum it now
         goes to the bag, where the pack panel opens on arrival and offers the
         second bottle.

         The Potli is an add-on rather than a bottle, so it does not count
         towards the minimum. */
      var bottles = bottleCount();
      /* Checkout is on this same domain, so there is nothing to open in a new
         tab. Doing so stranded people on a dead first tab with their bag on
         the other one. */
      order.removeAttribute('target');
      order.removeAttribute('rel');
      if (bottles < 2) {
        /* It used to rename itself to "Add one more bottle", which reads as an
           instruction rather than a way on and leaves the shopper arguing with
           the drawer. It goes to the bag instead, where the rule is explained
           once and the second bottle can be chosen. Nothing is disabled and
           nothing is hidden; the cart page is where the minimum is enforced. */
        order.href = '/cart';
        order.textContent = 'View bag · ' + money(subtotal);
      } else {
        /* The drawer reads the Shopify cart directly, so the cart already
           exists on the server and /checkout is simply where it continues.
           The permalink this used to build re-created the cart from a variant
           map hard-coded in shop-config.js, which silently dropped any line
           whose id had drifted. */
        order.href = '/checkout';
        order.textContent = 'Checkout · ' + money(subtotal);
      }
    }
  }

  function open() {
    offerSeed = Math.random();
    renderUpsell();
    var wasOpen = panel.classList.contains('open');
    panel.classList.add('open'); overlay.classList.add('open');
    panel.setAttribute('aria-hidden', 'false');
    if (!wasOpen) scrollLock.lock();
    document.getElementById('bagClose').focus();
  }
  function close() {
    var wasOpen = panel.classList.contains('open');
    panel.classList.remove('open'); overlay.classList.remove('open');
    panel.setAttribute('aria-hidden', 'true');
    if (wasOpen) scrollLock.unlock();
  }

  function add(n) {
    var variant = Number(product && product.vid);
    if (!variant) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: variant, quantity: n }] })
    }).then(function (r) { if (!r.ok) throw new Error(String(r.status)); return sync(); })
      .then(function () { renderMerch(); open(); })
      .catch(function () { window.location.href = '/cart'; });
    if (window.wellubiaTrack) window.wellubiaTrack('add_to_cart', {
      ecommerce: { currency: 'INR', value: unitPrice() * n, items: [{
        item_id: product.handle, item_name: product.name, price: unitPrice(), quantity: n
      }] }
    });
  }

  /* The buy form posts to /cart/add, which is the correct behaviour with no
     JavaScript: Shopify accepts it and returns the bag. With JavaScript the
     submit is caught here instead, so the bottle is added in the background
     and the drawer opens over the page.

     This used to bind to an element with the id addProduct, which no longer
     exists on either branch of the template. Nothing intercepted the submit,
     so pressing Add to bag reloaded the whole page into /cart and the drawer
     never appeared. Binding to the form covers both branches and does not
     depend on an id being present. */
  var buyForm = document.getElementById('buyForm');
  if (buyForm) buyForm.addEventListener('submit', function (event) {
    event.preventDefault();
    add(qty());
  });
  var stickyAdd = document.getElementById('stickyAdd');
  if (stickyAdd) stickyAdd.addEventListener('click', function () { add(qty()); });

  /* quantity stepper keeps Buy now in sync, so it buys what is on screen */
  function syncBuyNow() {
    if (!buyNow) return;
    buyNow.href = CFG.buyNowHref(product.handle, qty(), '../');
    if (CFG.external()) { buyNow.target = '_blank'; buyNow.rel = 'noopener'; }
    else { buyNow.removeAttribute('target'); buyNow.removeAttribute('rel'); }
    var s2 = document.querySelector('.sticky-buynow');
    if (s2) s2.href = buyNow.href;
  }
  document.querySelectorAll('.qty-step').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!qtyInput) return;
      qtyInput.value = Math.max(1, Math.min(99, qty() + Number(btn.dataset.qty)));
      syncBuyNow(); renderMerch();
    });
  });
  if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = qty(); syncBuyNow(); renderMerch(); });
  syncBuyNow();
  if (buyNow) buyNow.addEventListener('click', function () {
    if (window.wellubiaTrack) window.wellubiaTrack('begin_checkout', {
      ecommerce: { currency: 'INR', value: unitPrice() * qty(), items: [{
        item_id: product.handle, item_name: product.name, price: unitPrice(), quantity: qty()
      }] }
    });
  });
  if (order) order.addEventListener('click', function () {
    if (!bag.length || !CFG.external() || !window.wellubiaTrack) return;
    window.wellubiaTrack('begin_checkout', { ecommerce: {
      currency: 'INR',
      value: bag.reduce(function (s, i) { return s + i.price * i.qty; }, 0),
      items: bag.map(function (i) { return { item_id:i.handle, item_name:i.name, price:i.price, quantity:i.qty }; })
    }});
  });

  document.getElementById('bagButton').addEventListener('click', open);
  document.getElementById('bagClose').addEventListener('click', close);
  overlay.addEventListener('click', close);

  if (gallery) {
    var images = JSON.parse(gallery.dataset.galleryImages || '[]');
    var mainImage = gallery.querySelector('.gallery-main');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-index]'));
    var activeImage = 0;
    var showImage = function (index) {
      if (!images.length) return;
      activeImage = (index + images.length) % images.length;
      mainImage.src = images[activeImage];
      thumbs.forEach(function (thumb, i) {
        var on = i === activeImage;
        thumb.classList.toggle('active', on);
        thumb.setAttribute('aria-pressed', String(on));
      });
    };
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { showImage(Number(thumb.dataset.galleryIndex)); });
    });
    gallery.querySelector('.gallery-prev').addEventListener('click', function () { showImage(activeImage - 1); });
    gallery.querySelector('.gallery-next').addEventListener('click', function () { showImage(activeImage + 1); });
    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') showImage(activeImage - 1);
      if (e.key === 'ArrowRight') showImage(activeImage + 1);
    });
  }

  items.addEventListener('click', function (event) {
    var button = event.target.closest('button[data-action]');
    if (!button) return;
    var index = Number(button.dataset.index);
    var item = bag[index];
    if (!item) return;
    var next = button.dataset.action === 'remove' ? 0
      : item.qty + (button.dataset.action === 'plus' ? 1 : -1);
    button.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: item.line, quantity: Math.max(0, next) })
    }).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (d) readCart(d); else sync(); })
      .catch(function () { sync(); });
  });

  /* Merchandising under the buy row: how far the basket is from free
     shipping, what the next quantity break is worth, and when this batch
     was actually made. */
  function renderMerch() {
    var el = document.getElementById('merch');
    if (!el) return;
    var units = bag.reduce(function (s2, i) { return s2 + i.qty; }, 0) + qty();
    var value = bag.reduce(function (s2, i) { return s2 + price(i.price) * i.qty; }, 0) +
                unitPrice() * qty();
    var out = [];

    /* One line, not two. Delivery used to be stated on its own above, then
       again in the savings note below, then a third time in the strip at the
       top of the page. It belongs with the figure it adds to. */
    var ship = Number(CFG.DELIVERY_SAVING || 0);
    if (CFG.bundleState) {
      var b = CFG.bundleState(units, value);
      if (b.tier) {
        out.push('<p class="m-bundle on"><b>' + Math.round(b.tier.off * 100) +
                 '% off</b> at this quantity. You save ' + money(b.saved) +
                 (ship ? ', plus ' + money(ship) + ' delivery' : '') + '.</p>');
      } else if (b.next) {
        out.push('<p class="m-bundle">Delivery is free. Add <b>' + b.needs + ' more bottle' +
                 (b.needs === 1 ? '' : 's') + '</b> and save ' +
                 Math.round(b.next.off * 100) + '%.</p>');
      } else {
        out.push('<p class="m-ship done">Free delivery on every order across India.</p>');
      }
    } else {
      out.push('<p class="m-ship done">Free delivery on every order across India.</p>');
    }

    if (CFG.BATCH) {
      out.push('<p class="m-batch">Made in small batches. This one was made on <b>' +
               CFG.BATCH.made + '</b>; the next lands <b>' + CFG.BATCH.next + '</b>.</p>');
    }
    el.innerHTML = out.join('');
  }

  /* sticky bar appears once the main buy row has scrolled away */
  if (sticky) {
    var row = document.querySelector('.buy-row');
    if (row && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        sticky.classList.toggle('show', !visible);
        sticky.setAttribute('aria-hidden', String(visible));
      }, { threshold: 0 }).observe(row);
    }
  }

  addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  /* The header count is rendered by Liquid from cart.item_count, so it is
     already right before this runs. Sync corrects it for a page served from
     the back/forward cache, where the cart may have moved on since. */
  render();
  sync();
  renderMerch();
})();
